import React, { PureComponent } from 'react'
import { func, string, bool } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import Button from '@active/react-ui/Button'
import I18nMessage from '../I18nMessage'
import './GoogleButton.scss'

class GoogleButton extends PureComponent {
  static propTypes = {
    // For keycloak v5
    onIdpSignin: func,
    name: string,
    loginUrl: string,
    keycloakAPIServerHost: string,
    isPageModel: bool,
  }

  static defaultProps = {
    onIdpSignin: null,
    name: null,
    loginUrl: '',
    keycloakAPIServerHost: '',
    isPageModel: false,
  }

  handleGoogleSignin = clickEvent => {
    const {
      loginUrl, keycloakAPIServerHost, onIdpSignin, name, isPageModel,
    } = this.props
    // For keycloak v5 page
    if (isPageModel && loginUrl) {
      const keycloakOrigin = new URL(keycloakAPIServerHost).origin
      window.location.href = `${keycloakOrigin}${loginUrl}`
      return false
    }
    // For keycloak v5 widget
    if (onIdpSignin) {
      return onIdpSignin({ clickEvent, name })
    }
    return false
  }

  render() {
    return (
      <div className="passport-ui-app__google-button">
        <Responsive eqAbove="md">
          <Button type="secondary" className="passport__google-btn" 
            onClick={this.handleGoogleSignin}
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                  this.handleGoogleSignin()
                }
              }}
            >
            <i className="google-btn-icon" />
            <span className="google-btn-text">
              <I18nMessage id="passport.common.text.continueWithGoogle" />
            </span>
          </Button>
        </Responsive>
        <Responsive eqAbove="md" not>
          <Button type="secondary" className="passport__google-btn" onClick={this.handleGoogleSignin}>
            <i className="google-btn-icon" />
            <span className="google-btn-text">
              <I18nMessage id="passport.common.text.continueWithGoogle" />
            </span>
          </Button>
        </Responsive>
      </div>
    )
  }
}

export default withI18n(GoogleButton)
